export enum Language {
  // 简体中文
  SimplifiedChinese = 1,
  // 繁体中文
  TraditionalChinese = 2,
  // 英文
  English = 3,
}
